<div class="devices-wrapper" *ngrxLet="bookingStore.getBookingInstallations$ as installations">
  <ng-container *ngIf="installations; else loader">
    <ng-container
      *ngIf="
        selectedPlan !== BookingPlans.Trial && !installations && !searchTerm;
        else displayDevicesList
      "
    >
      <div
        class="error-container flex flex-col gap-[16px] lt-md:gap-[8px] justify-start items-center"
      >
        <img src="assets/img/installer-error.svg" />
        <h2>{{ '+BOOKING.PLANS.ERROR.TITLE' | translate }}</h2>
        <button
          class="back-button"
          gtm="onGoToPage"
          gtmAction="Home Page"
          gtmCategory="booking"
          mat-raised-button
          color="primary"
          [routerLink]="['/installations']"
        >
          <mat-icon>arrow_back</mat-icon>
          <span>{{ '+BOOKING.PLANS.ERROR.BTN' | translate }}</span>
        </button>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #loader>
    <vi-loader data-at-loader-booking [isLoading]="true"></vi-loader>
  </ng-template>

  <ng-template #displayDevicesList>
    <h2 class="devices-title">
      {{ '+BOOKING.VOUCHER.DEVICES.TITLE' | translate }}
    </h2>
    <div class="flex flex-row justify-between items-stretch">
      <div class="devices-content">
        <div class="devices-list-wrapper">
          <div class="devices-list">
            <div class="devices-list-header">
              <h3 class="devices-subtitle">
                {{ '+BOOKING.VOUCHER.DEVICES.SUBTITLE' | translate }}
              </h3>

              <app-installation-search
                search
                data-at-search-field
                [searchTerm]="searchTerm"
                [disabled]="installations && !installations.length && !searchTerm"
                categoryForGtm="booking"
                (search)="search($event)"
              ></app-installation-search>
            </div>

            <div>
              {{ '+BOOKING.VOUCHER.DEVICES.SELECT_DESC' | translate }}
            </div>

            <app-booking-devices-list>
              <ng-container
                *ngIf="bookingStore.isLoading$ | async; else deviceList"
                installation-item
              >
                <vi-loader [isLoading]="true"></vi-loader>
              </ng-container>
              <ng-template #deviceList installation-item>
                <ng-container
                  *ngIf="bookingStore.devicesCount$ | async; else noDevices"
                  installation-item
                >
                  <app-bookable-installation
                    class="devices-list-entry"
                    installation-item
                    data-at-device
                    *ngFor="
                      let device of bookingStore.bookingDevicesWithFilterAndPagination$ | async
                    "
                    [device]="device"
                    [isDisabled]="isDisabledForVoucher(device) | async"
                    [isSelected]="isSelectedInstallation(device) | async"
                    [isVoucherAvailable]="true"
                    (select)="onInstallationSelect(device)"
                    id="installation-{{ device.installationId }}"
                  ></app-bookable-installation>
                </ng-container>
                <ng-template installation-item #noDevices>
                  <div class="no-devices-message" *ngIf="!searchTerm">
                    {{ '+BOOKING.DEVICES.NO_DEVICES' | translate }}
                  </div>
                </ng-template>
              </ng-template>
              <mat-paginator
                *ngIf="bookingStore.pagination$ | async as pagination"
                data-at-paginator
                paginator
                [length]="bookingStore.devicesCount$ | async"
                [pageIndex]="pagination.page"
                [pageSize]="pagination.pageSize"
                (page)="onPageChange($event)"
                [disabled]="bookingStore.isLoading$ | async"
              ></mat-paginator>
            </app-booking-devices-list>
          </div>
        </div>
        <div class="devices-summary">
          <div class="devices-summary__cell">
            <div class="flex flex-row justify-between items-stretch">
              <p class="devices-summary__title">
                {{ '+BOOKING.VOUCHER.DEVICES.CHOSEN_PACKAGE' | translate }}
              </p>
              <button
                class="back-button"
                gtm="onGoToPage"
                gtmAction="Home Page"
                gtmCategory="booking"
                mat-stroked-button
                (click)="onBack()"
              >
                {{ 'GENERAL.BUTTON.BACK' | translate }}
              </button>
            </div>
            <div class="devices-summary__package">
              <p>
                {{
                  (selectedPlan === BookingPlans.Pro
                    ? '+BOOKING.PLAN.PRO_PACKAGE'
                    : '+BOOKING.PLAN.TRIAL_PACKAGE'
                  ) | translate
                }}
              </p>
              <ng-container *ngIf="bookingStore.trialSubscriptions$ | async as trialSubscriptions">
                <p
                  *ngIf="
                    selectedPlan === BookingPlans.Trial &&
                    trialSubscriptions.remaining &&
                    trialSubscriptions.total
                  "
                  class="test-info"
                >
                  {{ '+BOOKING.DEVICES.REMAINING_DEVICES' | translate }}
                  {{ trialSubscriptions.remaining }} /
                  {{ trialSubscriptions.total }}
                </p>
              </ng-container>
            </div>
          </div>

          <button
            class="next-step-button"
            data-at-buy-Pro-button
            mat-raised-button
            color="primary"
            [disabled]="!isAnyInstallationSelected || !(bookingStore.loaded$ | async)"
            (click)="nextStep()"
            gtm="onSelect"
            gtmAction="Pro package"
            gtmCategory="booking"
          >
            {{ '+BOOKING.VOUCHER.DEVICES.NEXT' | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
